export var APP_MODE = {
    WIDGET: 'widget',
    FULL_APP: 'fullApp',
};
export var AppMode;
(function (AppMode) {
    AppMode["Widget"] = "widget";
    AppMode["FullApp"] = "fullApp";
})(AppMode || (AppMode = {}));
//# sourceMappingURL=app-mode.js.map